export default "__VITE_ASSET__CrCpn8XX__"